import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { PROJECT_VIEW_SETTINGS } from 'src/modules/project-view/actions/ProjectViewActions';
import { saveProjectSettings } from 'src/modules/project-view/sagas/utils/saveProjectSettings';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { GetTriggerActionType } from 'src/utils/createTrigger';
import { call, select } from 'typed-redux-saga';

export function* projectViewSettingsSaga(
  action: GetTriggerActionType<typeof PROJECT_VIEW_SETTINGS>,
): SagaIterator<void> {
  const settings = action.data;
  const project = yield* select(getProjectDetails);

  try {
    yield* call(logDebug, 'Saving project settings settings...');
    yield* call(saveProjectSettings, project, settings);
    yield* call(logDebug, 'Saving project settings settings... done', settings);
  } catch (error) {
    yield* call(logError, 'Saving project settings settings... error', error);
    yield* call(sentryCatch, error);
  }
}
